import { render } from "./item.vue?vue&type=template&id=d1bbb0d4&scoped=true"
import script from "./item.vue?vue&type=script&lang=js"
export * from "./item.vue?vue&type=script&lang=js"

import "./item.vue?vue&type=style&index=0&id=d1bbb0d4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-d1bbb0d4"

export default script